// StatusBar component for displaying simulation statistics

import React from 'react';
import Icon from '../../../core/Icon';
import { StatusBarContainer, StatusItem } from '../styles';

interface StatusBarProps {
  roomCount: number;
  testGatewayCount: number;
  testBraceletCount: number;
  patientsWithBraceletsCount: number;
  syncCount: number;
  lastSync: Date | null;
}

export const StatusBar: React.FC<StatusBarProps> = ({
  roomCount,
  testGatewayCount,
  testBraceletCount,
  patientsWithBraceletsCount,
  syncCount,
  lastSync,
}) => (
  <StatusBarContainer>
    <StatusItem>
      <Icon className="material-icons" style={{ fontSize: '1rem' }}>
        meeting_room
      </Icon>
      {roomCount} rooms
    </StatusItem>
    <StatusItem>
      <Icon className="material-icons" style={{ fontSize: '1rem' }}>
        router
      </Icon>
      {testGatewayCount} test gateways
    </StatusItem>
    <StatusItem>
      <Icon className="material-icons" style={{ fontSize: '1rem' }}>
        bluetooth
      </Icon>
      {testBraceletCount} test bracelets registered
    </StatusItem>
    <StatusItem>
      <Icon className="material-icons" style={{ fontSize: '1rem' }}>
        person
      </Icon>
      {patientsWithBraceletsCount} patients with test bracelets
    </StatusItem>
    {lastSync && (
      <StatusItem>
        <Icon className="material-icons" style={{ fontSize: '1rem' }}>
          sync
        </Icon>
        {syncCount} syncs
      </StatusItem>
    )}
  </StatusBarContainer>
);
